<template>
  <v-data-table light class="elevation-1" :headers="headers" :items="indicators" hide-actions>
    <template #headerCell="{ header }">
      {{ header.text }}
      <template v-if="header.value === 'check'">
        <v-checkbox v-model="selectAllIndicators" color="success" hide-details @change="toggleAllIndicators()" />
      </template>
    </template>
    <template #items="{ item: indicator }">
      <td class="pr-1">
        <v-checkbox v-model="selectedIndicators" :value="indicator.sequence" color="success" hide-details @change="selectIndicator(indicator)" />
      </td>
      <td class="pl-1" :class="{ 'pl-4': indicator.parent }">
        <v-chip label small dark color="blue-grey">{{ indicator.sequence }}</v-chip>
        {{ indicator.title }}
      </td>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    period: {
      type: String,
      required: true
    }
  },
  data: () => ({
    selectedIndicators: [],
    selectAllIndicators: true,

    headers: [
      {
        text: '',
        sortable: false,
        value: 'check'
      },
      {
        text: 'Показатель',
        sortable: false,
        value: 'title',
      }
    ],
    indicators_2020: [
      {
        sequence: '1',
        title: 'Количество преподавателей, выполняющих нагрузку в объеме более 0,5 ставки',
        unit: '1 преподаватель',
        award: 0,
        empty: true,
      },
      {
        sequence: '2',
        title: 'Количество докторов наук, докторов философии (PhD), кандидатов наук РК',
        unit: '1 преподаватель',
        award: 50,
        empty: true,
      },
      {
        sequence: '3',
        title: 'Количество  преподавателей, получивших ученую степень:',
        hasChildren: true,
      },
      {
        sequence: '3.1',
        parent: '3',
        title: 'доктор  наук СНГ',
        unit: '1 преподаватель',
        award: 1000,
        byTeacher: true,
        indicators: ['fddf614e-fce8-4474-a1a9-ae4a7090e273']
      },
      {
        sequence: '3.2',
        parent: '3',
        title: 'кандидат наук СНГ, доктор PhD РК и других стран, в т.ч. после переаттестации кандидата наук СНГ',
        unit: '1 преподаватель',
        award: 600,
        byTeacher: true,
        indicators: ['17b50a59-fc5a-41f2-839e-726c6aec88d8']
      },
      {
        sequence: '3.3',
        parent: '3',
        title: 'заслуженный тренер РК',
        unit: '1 преподаватель',
        award: 600,
        byTeacher: true,
        indicators: ['f2c804a9-24c7-454c-98c0-23dc940ffb20']
      },
      {
        sequence: '4',
        title: 'Количество  преподавателей, получивших ученое звание или судейскую категорию:',
        hasChildren: true,
      },
      {
        sequence: '4.1',
        parent: '4',
        title: 'профессора КОКСО / судьи Международной категории',
        unit: '1 преподаватель',
        award: 800,
        byTeacher: true,
        indicators: ['fab3df1d-938f-4029-8b5b-255704af895a']
      },
      {
        sequence: '4.2',
        parent: '4',
        title: 'ассоциированного профессора (доцента) КОКСО / судьи Высшей национальной категории',
        unit: '1 преподаватель',
        award: 600,
        byTeacher: true,
        indicators: ['a10e63c8-2b57-45ac-b9bb-63ca9f56f718']
      },
      {
        sequence: '5',
        title: 'Количество  преподавателей, получивших грант и звание «Лучший преподаватель вуза»',
        unit: '1 преподаватель',
        award: 100,
        byTeacher: true,
        indicators: ['63ae509d-fce2-440a-86e5-477e5916943e']
      },
      {
        sequence: '6',
        title: 'Количество наград, полученных преподавателями кафедры:',
        hasChildren: true,
      },
      {
        sequence: '6.1',
        parent: '6',
        title: 'мирового уровня',
        unit: '1 диплом, медаль, нагрудный знак',
        award: 500,
        indicators: ['ac7d0306-b2b3-42e1-b6d2-e6c01651ec8f']
      },
      {
        sequence: '6.2',
        parent: '6',
        title: 'государственные РК',
        unit: '1 диплом, медаль, нагрудный знак',
        award: 400,
        indicators: ['80637e53-6b39-4fc0-80a2-07434c9637b4']
      },
      {
        sequence: '6.3',
        parent: '6',
        title: 'ведомственные (нагрудные знаки, медали)',
        unit: '1 диплом, медаль, нагрудный знак',
        award: 250,
        indicators: ['c53b9721-f91c-45c7-ba8e-f57afe631e06']
      },
      {
        sequence: '7',
        title: 'Количество преподавателей, прошедших профессиональную переподготовку, повышение квалификации в организациях образования, научно-исследовательских организациях, организациях  дополнительного образования по общепедагогическому направлению.',
        unit: '1 преподаватель',
        award: 200,
        byTeacher: true,
        indicators: ['9a49f285-ef47-4097-b141-b4d5cc1ab6c6']
      },
      {
        sequence: '8',
        title: 'Количество преподавателей, прошедших профессиональную переподготовку, повышение квалификации или стажировку по специальности в организациях  образования, научно-исследовательских организациях, организациях  дополнительного образования, на предприятиях:',
        hasChildren: true,
      },
      {
        sequence: '8.1',
        parent: '8',
        title: 'зарубежных (в том числе с приглашением зарубежного лектора, дистанционные);',
        unit: '1 преподаватель',
        award: 200,
        byTeacher: true,
        indicators: ['d24606da-97a3-4846-961f-6b5a42a6ef07']
      },
      {
        sequence: '8.2',
        parent: '8',
        title: 'республиканских (в том числе с приглашением лектора из республиканской организации, дистанционные);',
        unit: '1 преподаватель',
        award: 150,
        byTeacher: true,
        indicators: ['4a3fd95c-3519-4371-a3ec-32ca399264bb']
      },
      {
        sequence: '8.3',
        parent: '8',
        title: 'областных.',
        unit: '1 преподаватель',
        award: 100,
        byTeacher: true,
        indicators: ['e8cce244-6141-4029-97f9-50c82c5e5304']
      },
      {
        sequence: '9',
        title: 'Количество преподавателей, прошедших обучение на курсах английского языка:',
        hasChildren: true,
      },
      {
        sequence: '9.1',
        parent: '9',
        title: 'продвинутый уровень;',
        unit: '1 преподаватель',
        award: 300,
        byTeacher: true,
        indicators: ['f1b97f4f-eb9a-431a-8341-7a88d74e6b29']
      },
      {
        sequence: '9.2',
        parent: '9',
        title: 'средний уровень;',
        unit: '1 преподаватель',
        award: 200,
        byTeacher: true,
        indicators: ['cbec4d6a-8d03-4bab-b2cf-ac1806c6816b']
      },
      {
        sequence: '9.3',
        parent: '9',
        title: 'начинающий уровень.',
        unit: '1 преподаватель',
        award: 150,
        byTeacher: true,
        indicators: ['c24538f9-2fc9-4610-99a6-f30ad1aaada0']
      },
      {
        sequence: '10',
        title: 'Количество преподавателей, получивших сертификат TOEFL, IELTS, FCE, CAE, TKT, ICELT, CELTA, DELTA, TESOL, Goethe-Zertifikat, DELF, DALF, TFI, TCF, DSH, TestDaF, DET,CEFR',
        unit: '1 преподаватель',
        award: 500,
        byTeacher: true,
        indicators: ['1f27140d-67b5-49bd-bc95-5bb4c97c186b']
      },
      {
        sequence: '11',
        title: 'Количество изданных учебников, учебных пособий с грифом МОН РК:',
        hasChildren: true,
      },
      {
        sequence: '11.1',
        parent: '11',
        title: 'на каз. и рус. языках',
        unit: '1 учебное пособие, учебник, ЭУИ',
        award: 1000,
        indicators: ['3e8cd781-a257-467b-8c3e-f8e831cffc2a']
      },
      {
        sequence: '11.2',
        parent: '11',
        title: 'на англ. языке',
        unit: '1 учебное пособие, учебник, ЭУИ',
        award: 2000,
        indicators: ['3b970134-3cef-4c29-ba9a-4895f66d6ace']
      },
      {
        sequence: '12',
        title: 'Количество полученных рекомендаций  к изданию учебников, учебных пособий УМО РУМС базового вуза:',
        hasChildren: true,
      },
      {
        sequence: '12.1',
        parent: '12',
        title: 'на каз. и рус. языках',
        unit: '1 учебное пособие, учебник, ЭУИ',
        award: 500,
        indicators: ['97217c73-3b2e-447e-a46c-150e42170cac']
      },
      {
        sequence: '12.2',
        parent: '12',
        title: 'на англ. языке',
        unit: '1 учебное пособие, учебник, ЭУИ',
        award: 1000,
        indicators: ['8c5c98c9-6c00-49c3-b652-f9d6dd59f9ab']
      },
      {
        sequence: '13',
        title: 'Количество изданных учебных и учебно-методических пособий, утвержденных УМС университета (с ISBN)',
        unit: '1 учебное пособие, учебник',
        award: 300,
        indicators: ['0c60afae-e883-4c65-b85c-d63343c7c702', 'a12ae085-7156-4ba4-af7a-d3605a0d2bc6']
      },
      {
        sequence: '14',
        title: 'Количество разработанных ЭУИ (в том, числе комлекс виртуальных лабораторных работ и моделирующих программ), утвержденных УМС университета',
        unit: '1 ЭУИ',
        award: 200,
        indicators: ['d6d919d9-1cde-4485-bfb8-54a17bc3c2e7']
      },
      {
        sequence: '15',
        title: 'Количество разработанных видеолекций по дисциплинам, утвержденных УМС университета',
        unit: '1 видео-лекция',
        award: 100,
        indicators: ['51b3ab17-e88c-4cca-8201-547d66fc259c']
      },
      {
        sequence: '16',
        title: 'Количество образовательных программ, закрепленных за кафедрой по которым ведется обучение в текущем учебном году:',
        hasChildren: true,
        empty: true,
      },
      {
        sequence: '16.1',
        parent: '16',
        title: 'бакалавриата;',
        unit: '1 ОП',
        award: 250,
        empty: true,
      },
      {
        sequence: '16.2',
        parent: '16',
        title: 'магистратуры;',
        unit: '1 ОП',
        award: 200,
        empty: true,
      },
      {
        sequence: '16.3',
        parent: '16',
        title: 'докторантуры.',
        unit: '1 ОП',
        award: 150,
        empty: true,
      },
      {
        sequence: '17',
        title: 'Количество реализуемых двудипломных образовательных программ',
        unit: '1 программа',
        award: 400,
        empty: true,
      },
      {
        sequence: '18',
        title: 'Количество преподавателей, проводивших занятия по одному предмету или модулю учебного плана в других вузах, в т.ч. казахстанских, иногородних',
        unit: '1 преподаватель',
        award: 300,
        empty: true,
      },
      {
        sequence: '19',
        title: 'Количество обучающихся, участвующих во внутренней академической мобильности',
        hasChildren: true,
        empty: true,
      },
      {
        sequence: '19.1',
        parent: '19',
        title: 'исходящая',
        unit: '1 обучающийся',
        award: 75,
        empty: true,
      },
      {
        sequence: '19.2',
        parent: '19',
        title: 'входящая',
        unit: '1 обучающийся',
        award: 100,
        empty: true,
      },
      {
        sequence: '20',
        title: 'Количество иностранных студентов на выпускающей кафедре, обучающихся на постоянной основе',
        unit: '1 обучающийся',
        award: 50,
        empty: true,
      },
      {
        sequence: '21',
        title: 'Количество действующих дистанционных курсов в Moodle, преподаваемых кафедрой в текущем учебном году',
        unit: '1 дисциплина',
        award: 10,
        empty: true,
      },
      {
        sequence: '22',
        title: 'Количество дистанционных олимпиад проведенных кафедрой  для старшеклассников и выпускников колледжей  (на платформе дистанционного обучения университета)',
        unit: '1 олимпиада',
        award: 200,
        indicators: ['50718d48-90b4-4483-a1f5-09618a22dcb3']
      },
      {
        sequence: '23',
        title: 'Количество разработанных и внедренных курсов на платформах массовых открытых он-лайн курсов',
        unit: '1 курс',
        award: 2000,
        indicators: ['e517db52-9665-4012-b92e-2e7a18cd84d0']
      },
      {
        sequence: '24',
        title: 'Количество ППС кафедры, получивших сертификаты об успешном прохождении обучения по курсу на базе платформы массовых открытых онлайн курсов по профессиональной деятельности (на базе платформ Coursera, EdX, Udacity, FutureLearn):',
        hasChildren: true,
      },
      {
        sequence: '24.1',
        parent: '24',
        title: 'на каз. и рус. языках',
        unit: '1 преподаватель',
        award: 200,
        byTeacher: true,
        indicators: ['482efb8e-5384-4c31-9fd1-b01002d4f7c7']
      },
      {
        sequence: '24.2',
        parent: '24',
        title: 'на англ. языке',
        unit: '1 преподаватель',
        award: 400,
        byTeacher: true,
        indicators: ['8a110e1a-abb9-4dc9-8ff9-802f8f448300']
      },
      {
        sequence: '25',
        title: 'Количество ППС кафедры, участвующих в проекте «Корпоративного обучения»',
        unit: '1 преподаватель',
        award: 200,
        byTeacher: true,
        indicators: ['90fcfab6-24bd-47df-a079-1f37d0e9775f', '408d0e20-ffe1-4e2b-9b01-118d34bbaf40', '9386d568-f9a8-4888-9255-411dcb8fcd25']
      },
      {
        sequence: '26',
        title: 'Оказание образовательных услуг с перечислением средств на счет университета, в том числе проведение специализированных курсов для сторонних организаций, сотрудников КРУ и других лиц',
        unit: '100 тыс. тенге',
        coefficient: 100000,
        award: 100,
        indicators: ['5531fc0b-c2ae-4042-a88b-5101e3b3314a']
      },
      {
        sequence: '27',
        title: 'Количество неязыковых дисциплин, преподаваемых преподавателями кафедры на английском языке.',
        unit: '1 дисциплина',
        award: 200,
        indicators: ['37043f6e-9d8c-4857-b58a-b0c6589589ef']
      },
      {
        sequence: '28',
        title: 'Количество реализуемых научных проектов с грантовым финансированием',
        unit: '1 проект',
        award: 600,
        indicators: ['445a4bf8-5f15-40af-af6f-dd3779a40225']
      },
      {
        sequence: '29',
        title: 'Количество разрабатываемых тем НИР (грант научных проектов МОН, инициативные и др.), зарегистрированных в НЦГНТЭ',
        unit: '1 отчет',
        award: 200,
        indicators: ['7086dc9b-0f8d-4329-b2e3-832d59433c13']
      },
      {
        sequence: '30',
        title: 'Государственно-частное партнерство с финансированием – за каждые 100 тыс. тенге, поступивших на счет университета по хоздоговору',
        unit: '100 тыс. тенге',
        coefficient: 100000,
        award: 100,
        indicators: ['9c307f0d-39c0-44b6-919e-01dc1a4f98dd']
      },
      {
        sequence: '31',
        title: 'Количество обучающихся, победителей конкурсов НИРС (НИРМ)  предметных олимпиад, которых подготовил ППС кафедры:',
        hasChildren: true,
        empty: true,
      },
      {
        sequence: '31.1',
        parent: '31',
        title: 'республиканских МОН РК',
        unit: '1  диплом, грамота',
        award: 300,
        empty: true,
        // indicators: ['7e519e8a-92de-4a48-9afd-d63931d6a948']
      },
      {
        sequence: '31.2',
        parent: '31',
        title: 'республиканских МОН РК (для школьников)',
        unit: '1  диплом, грамота',
        award: 50,
        empty: true,
        // indicators: ['2752b04e-4739-4e53-beac-4b4f5bdd6f1b']
      },
      {
        sequence: '31.3',
        parent: '31',
        title: 'международных (в т.ч. в РК)',
        unit: '1  диплом, грамота',
        award: 300,
        empty: true,
        // indicators: ['880d9b7b-4c4a-4cb6-aa25-a683afd27777']
      },
      {
        sequence: '32',
        title: 'Количество внедренных результатов НИР ППС',
        hasChildren: true,
      },
      {
        sequence: '32.1',
        parent: '32',
        title: 'внедрение патента в производство (бизнес) с оплатой на счет университета от 50 тысяч тенге',
        unit: '1 акт внедрения',
        award: 1000,
        indicators: ['3b91a7fa-9b00-4b22-aead-e274e58c9df5']
      },
      {
        sequence: '32.2',
        parent: '32',
        title: 'акт внедрения в производственный процесс (по темам НИР ППС, зарегистрированным в НЦГНТЭ)',
        unit: '1 акт внедрения',
        award: 50,
        indicators: ['f5e65202-41bf-4ed8-bf77-39763c00f589']
      },
      {
        sequence: '32.3',
        parent: '32',
        title: 'акт внедрения в учебный процесс',
        unit: '1 акт внедрения',
        award: 40,
        indicators: ['4d57a7c9-2260-4271-a2e8-fe784e312125']
      },
      {
        sequence: '33',
        title: 'Количество студенческих',
        hasChildren: true,
      },
      {
        sequence: '33.1',
        parent: '33',
        title: 'стартапов с регистрацией бизнеса, подтверждённых созданием рабочих мест и налоговыми отчислениями',
        unit: '1 стартап, бизнес-проект',
        award: 2000,
        indicators: ['eb26a64d-a515-4e38-a6ab-5762225a44f9']
      },
      {
        sequence: '33.2',
        parent: '33',
        title: 'бизнес-проектов и эссе, выигравших грантовое финансирование',
        unit: '1 стартап, бизнес-проект',
        award: 200,
        indicators: ['7992f14e-35ce-4fe8-a900-39f5f612eb42']
      },
      {
        sequence: '34',
        title: 'Количество организованных научных и методических мероприятий',
        hasChildren: true,
        empty: true
      },
      {
        sequence: '34.1',
        parent: '34',
        title: 'международного уровня в рамках конференций «Байтурсыновские чтения», «Султангазинские чтения», «Алтынсаринские чтения»',
        unit: '1 мероприятие',
        award: 300,
        empty: true,
      },
      {
        sequence: '34.2',
        parent: '34',
        title: 'региональных',
        unit: '1 мероприятие',
        award: 100,
        empty: true,
      },
      {
        sequence: '34.3',
        parent: '34',
        title: 'институтского и кафедрального уровней',
        unit: '1 мероприятие',
        award: 50,
        empty: true,
      },
      {
        sequence: '35',
        title: 'Количество полученных:',
        hasChildren: true,
      },
      {
        sequence: '35.1',
        parent: '35',
        title: 'патентов',
        unit: '1 патент',
        award: 500,
        indicators: ['fdc92c51-98ae-41b2-9619-a9453b40904b']
      },
      {
        sequence: '35.2',
        parent: '35',
        title: 'свидетельств интеллектуальной собственности',
        unit: '1 свидетельство',
        award: 500,
        indicators: ['b5a93a69-6723-42ac-acd2-6edf789d8685']
      },
      {
        sequence: '35.3',
        parent: '35',
        title: 'свидетельство интеллектуальной собственности на ЭУИ',
        unit: '1 свидетельство',
        award: 500,
        indicators: ['f4313ff5-9f53-4668-aa4b-99129ee4e4f9']
      },
      {
        sequence: '35.4',
        parent: '35',
        title: 'публикации патентов  в патентной базе Derwent Innovations Index компании Creative Analytics',
        unit: '1 публикация',
        award: 200,
        indicators: ['da7b0fcb-2a06-40a7-9f78-6476bfc68f89']
      },
      {
        sequence: '36',
        title: 'Количество изданных монографий:',
        hasChildren: true,
      },
      {
        sequence: '36.1',
        parent: '36',
        title: 'на рус.языке',
        unit: '1 монография',
        award: 400,
        indicators: ['60acaa55-350f-4676-bdcc-9305c48cd903']
      },
      {
        sequence: '36.2',
        parent: '36',
        title: 'на каз.языке',
        unit: '1 монография',
        award: 500,
        indicators: ['2b4e6b0d-c23a-4ef9-bb54-58fd89cad141']
      },
      {
        sequence: '36.3',
        parent: '36',
        title: 'на англ.языке',
        unit: '1 монография',
        award: 1000,
        indicators: ['b6e344b3-208a-4c28-ad88-5ee9d5939241']
      },
      {
        sequence: '37',
        title: 'Количество опубликованных научных статей в научных изданиях (в т.ч. со студентами, магистрантами, докторантами):',
        hasChildren: true,
      },
      {
        sequence: '37.1',
        parent: '37',
        title: 'индексируемых в Web of Science, Thomson Reuters, Scopus',
        unit: '1 статья',
        award: 1000,
        indicators: ['161b52a4-b9ed-43dc-ba22-11bdffb623f6']
      },
      {
        sequence: '37.2',
        parent: '37',
        title: 'индексируемых в Pubmed, zbMath, MathScinet, Agris, Georef, Astrophysical journal',
        unit: '1 статья',
        award: 500,
        indicators: ['6c2ed314-f7b2-48fb-9956-8b71906f29dd']
      },
      {
        sequence: '37.3',
        parent: '37',
        title: 'в журналах, рекомендованных КОКСО МОН РК',
        unit: '1 статья',
        award: 250,
        indicators: ['131590b8-cab1-445f-b115-5a384d9709b7']
      },
      {
        sequence: '37.4',
        parent: '37',
        title: 'в журналах, рекомендованных ВАК России, Белоруссии, Кыргизстана',
        unit: '1 статья',
        award: 150,
        indicators: ['30f02cd9-d009-42dc-8587-db1937f65d40']
      },
      {
        sequence: '37.5',
        parent: '37',
        title: 'зарубежных, в том числе в странах СНГ',
        unit: '1 статья',
        award: 150,
        indicators: ['b004c6a5-2ce1-4e23-b4f0-1356ad837ac3']
      },
      {
        sequence: '37.6',
        parent: '37',
        title: 'в других республиканских изданиях',
        unit: '1 статья',
        award: 100,
        indicators: ['84dd6c13-80e5-4b02-bb2a-20fa1b6a3634']
      },
      {
        sequence: '37.7',
        parent: '37',
        title: 'в журнале «3i» (кроме с/х и вет, которые входят в КОКСО), «Вестник КГПИ»  на анг. и каз. языках',
        unit: '1 статья',
        award: 200,
        indicators: ['4bfd1e1b-ad62-4998-9d36-77a9672101a8']
      },
      {
        sequence: '37.8',
        parent: '37',
        title: 'в журнале «3i» (кроме с/х и вет, которые входят в КОКСО), «Вестник КГПИ»  на рус. языке, которые входят в КОКСО МОН РК',
        unit: '1 статья',
        award: 150,
        indicators: ['cfb2c267-8919-47c4-bab6-7f8288ea1025']
      },
      {
        sequence: '37.9',
        parent: '37',
        title: 'совместные публикации в журналах «3i», «Вестник КГПИ» с иностранным ученым',
        unit: '1 статья',
        award: 50,
        indicators: ['733c4517-69ff-4ae6-ae37-d9d66f285a5a']
      },
      {
        sequence: '38',
        title: 'Количество ППС кафедры, имеющих h-индекс (индекс Хирша) 2 и более',
        unit: '1 преподаватель',
        award: 500,
        byTeacher: true,
        indicators: ['b6a573a6-bcc9-44cb-a05a-f9fcb83e0480']
      },
      {
        sequence: '39',
        title: 'Количество публикаций (в т.ч. со студентами, магистрантами, докторантами) в трудах научных конференций:',
        hasChildren: true,
      },
      {
        sequence: '39.1',
        parent: '39',
        title: 'международных (зарубежных)',
        unit: '1 публикация',
        award: 150,
        indicators: ['72a3ab07-166d-4321-a2e6-d2d92c026a66']
      },
      {
        sequence: '39.2',
        parent: '39',
        title: 'международных (в странах СНГ)',
        unit: '1 публикация',
        award: 100,
        indicators: ['26992ba1-f48d-47a1-88ca-af3652014014']
      },
      {
        sequence: '39.3',
        parent: '39',
        title: 'международных (в РК)',
        unit: '1 публикация',
        award: 80,
        indicators: ['2722770a-ac05-4eea-a806-6533f5a715bb']
      },
      {
        sequence: '39.4',
        parent: '39',
        title: 'республиканских, областных, городских',
        unit: '1 публикация',
        award: 50,
        indicators: ['f1d65518-bfe9-4848-8b5c-f0465b3a9e62']
      },
      {
        sequence: '39.5',
        parent: '39',
        title: '«Байтурсыновские чтения», «Султангазинские чтения», «Алтынсаринские чтения»  и другие под эгидой ректора КГУ',
        unit: '1 публикация',
        award: 150,
        indicators: ['8e2fa1d5-2fcc-4b15-b7d5-ad6126a8b1a8']
      },
      {
        sequence: '40',
        title: 'Количество реализуемых международных проектов с грантовым финансированием',
        unit: '1 проект',
        award: 600,
        indicators: ['c4df8dd3-9953-4fdf-9526-892512c22e0f']
      },
      {
        sequence: '41',
        title: 'Количество реализуемых международных договоров, партнерских двусторонних соглашений с университетами, научными, дипломатическими организациями:',
        hasChildren: true,
      },
      {
        sequence: '41.1',
        parent: '41',
        title: 'зарубежья',
        unit: '1 договор, соглашение',
        award: 400,
        indicators: ['611cd3f6-befb-49cf-85a6-dfee7b86057d']
      },
      {
        sequence: '41.2',
        parent: '41',
        title: 'стран ЕврАзЭС',
        unit: '1 договор, соглашение',
        award: 200,
        indicators: ['d2d03cf4-dd1b-4fcb-b95d-50942d214ff1']
      },
      {
        sequence: '42',
        title: 'Количество командировок и стажировок в зарубежные образовательные и научные учреждения:',
        hasChildren: true,
      },
      {
        sequence: '42.1',
        parent: '42',
        title: 'командировка (длительность до 5 дней)',
        unit: '1 командировка',
        award: 50,
        indicators: ['5b4df036-e377-4cee-bccc-ccec7e6d67ba']
      },
      {
        sequence: '42.2',
        parent: '42',
        title: 'стажировка',
        unit: '1 стажировка',
        award: 200,
        indicators: ['e7332550-3f68-457e-be6a-bb131eb8eff0']
      },
      {
        sequence: '43',
        title: 'Количество зарубежных ученых, приглашенных в университет:',
        hasChildren: true,
        empty: true
      },
      {
        sequence: '43.1',
        parent: '43',
        title: 'не менее 1-ой недели',
        unit: '1 ученый',
        award: 300,
        empty: true,
      },
      {
        sequence: '43.2',
        parent: '43',
        title: 'менее 1-ой недели',
        unit: '1 ученый',
        award: 50,
        empty: true,
      },
      {
        sequence: '44',
        title: 'Количество обучающихся, участвующих во внешней академической мобильности (на семестр, год):',
        hasChildren: true,
        empty: true
      },
      {
        sequence: '44.1',
        parent: '44',
        title: 'исходящая',
        unit: '1 обучающийся',
        award: 150,
        empty: true,
      },
      {
        sequence: '44.2',
        parent: '44',
        title: 'входящая',
        unit: '1 обучающийся',
        award: 200,
        empty: true,
      },
      {
        sequence: '45',
        title: 'Количество преподавателей, являющихся кураторами групп',
        unit: '1 преподаватель',
        award: 50,
        byTeacher: true,
        indicators: ['8c0efb08-1bb5-41ec-8d7b-a5084d52ac3a']
      },
      {
        sequence: '46-1',
        title: 'Количество преподавателей, являющихся победителями конкурсов «Лучший куратор института» (1,2,3 места)',
        unit: '1 преподаватель',
        award: 200,
        byTeacher: true,
        indicators: ['944a67be-ddd7-430c-aa3b-1214adb6e473', 'ea5c6c6e-628a-49b5-8eb7-b630e14754a4', '6d5d4b17-5008-40c4-abf8-0c6cb9e81777']
      },
      {
        sequence: '46-2',
        title: 'Количество преподавателей, являющихся победителями конкурсов «Лучший куратор университета» (1,2,3 места)',
        unit: '1 преподаватель',
        award: 200,
        byTeacher: true,
        indicators: ['6d5d4b17-5008-40c4-abf8-0c6666e81b11', '6d5d4b17-5008-40c4-abf8-0c6666e81b22', '6d5d4b17-5008-40c4-abf8-0c6666e81b33']
      },
      {
        sequence: '47',
        title: 'Количество преподавателей, проводивших воспитательные мероприятия на базе университета:',
        hasChildren: true,
      },
      {
        sequence: '47.1',
        parent: '47',
        title: 'международного уровня',
        unit: '1 преподаватель',
        award: 300,
        byTeacher: true,
        indicators: ['9a91e72a-f3a0-423d-8e56-a08d1921dc27']
      },
      {
        sequence: '47.2',
        parent: '47',
        title: 'республиканского уровня',
        unit: '1 преподаватель',
        award: 200,
        byTeacher: true,
        indicators: ['3027c4c1-ab73-46fe-abaa-4c60da16f63a']
      },
      {
        sequence: '47.3',
        parent: '47',
        title: 'университетского уровня',
        unit: '1 преподаватель',
        award: 100,
        byTeacher: true,
        indicators: ['dff92e56-69dd-48ac-b9dc-4995d94c5da1']
      },
      {
        sequence: '47.4',
        parent: '47',
        title: 'кафедрального уровня',
        unit: '1 преподаватель',
        award: 50,
        byTeacher: true,
        indicators: ['bfc107d4-7a47-463d-a0c5-444a09882e21']
      },
      {
        sequence: '48',
        title: 'Количество обучающихся, призеров фестивалей, конкурсов, турниров:',
        hasChildren: true,
        empty: true,
      },
      {
        sequence: '48.1',
        parent: '48',
        title: 'международных',
        unit: '1 обучающийся',
        award: 300,
        empty: true,
        // indicators: ['']
      },
      {
        sequence: '48.2',
        parent: '48',
        title: 'республиканских',
        unit: '1 обучающийся',
        award: 200,
        empty: true,
        // indicators: ['']
      },
      {
        sequence: '48.3',
        parent: '48',
        title: 'областных',
        unit: '1 обучающийся',
        award: 100,
        empty: true,
        // indicators: ['']
      },
      {
        sequence: '49',
        title: 'Количество обучающихся, призеров спортивных соревнований (1,2,3 место в личных и общекомандных соревнованиях):',
        hasChildren: true,
      },
      {
        sequence: '49.1',
        parent: '49',
        title: 'международных (зарубежных)',
        unit: '1 обучающийся',
        award: 400,
        indicators: ['e1efaa16-f65d-4e1e-b9e2-5f9a6e279f96']
      },
      {
        sequence: '49.2',
        parent: '49',
        title: 'международных (в РК)',
        unit: '1 обучающийся',
        award: 300,
        indicators: ['a3665548-b340-4406-8952-d34479a34df5']
      },
      {
        sequence: '49.3',
        parent: '49',
        title: 'республиканские',
        unit: '1 обучающийся',
        award: 200,
        indicators: ['d16fae7e-cda9-41e6-9425-3e381b795707']
      },
      {
        sequence: '50',
        title: 'Количество обучающихся, получивших:',
        hasChildren: true,
      },
      {
        sequence: '50.1',
        parent: '50',
        title: 'мастера спорта международного класса',
        unit: '1 обучающийся',
        award: 200,
        indicators: ['5de22343-3af2-4c4e-b224-bcfa2f5da8d7']
      },
      {
        sequence: '50.2',
        parent: '50',
        title: 'мастера спорта РК',
        unit: '1 обучающийся',
        award: 150,
        indicators: ['1e6c4dd1-39f4-471c-a4be-aab427201f1b']
      },
      {
        sequence: '50.3',
        parent: '50',
        title: 'кандидата в мастера спорта (первый взрослый разряд по игровым видам спорта)',
        unit: '1 обучающийся',
        award: 100,
        indicators: ['df0d1f67-32ed-4562-8c52-798c0ba7f073']
      },
      {
        sequence: '51',
        title: 'Количество обучающихся, участников волонтерского движения',
        unit: '1 обучающийся',
        award: 100,
        empty: true,
      },
      {
        sequence: '52',
        title: 'Количество обучающихся, участников студенческих клубов, трудовых отрядов,  творческих объединений , членов общественных молодежных организаций и др.',
        unit: '1 обучающийся',
        award: 50,
        empty: true,
      },
      {
        sequence: '53',
        title: 'Набор студентов на 1 курс очной формы обучения',
        unit: '1 обучающийся',
        award: 10,
        empty: true,
      },
      {
        sequence: '54',
        title: 'Количество малокомплектных групп в бакалавриате',
        unit: '1 группа',
        award: -100,
        empty: true,
      },
      {
        sequence: '55',
        title: 'Количество иностранных обучающихся',
        unit: '1 обучающийся',
        award: 100,
        empty: true,
      },
      {
        sequence: '56',
        title: 'Выступления и размещение кафедрами информации об образовательных программах кафедр, деятельности университета в средствах массовой информации',
        unit: '1 статья, эфирная справка с указанием тематики выхода',
        award: 50,
        indicators: ['d4b96575-121c-41bb-bc9e-957a9c128dbf']
      },
      {
        sequence: '57',
        title: 'Итоги рейтинга НПП РК «Атамекен»',
        unit: '',
        award: 0,
        empty: true,
      },
      {
        sequence: '58',
        title: 'Дополнительные баллы по предложению директора института и руководителей структурных подразделений университета  за выполнение определенных видов работы.',
        unit: '',
        award: 0,
        empty: true,
      },
    ],
    indicators_2021: [
      {
        sequence: '1',
        title: 'Количество преподавателей, выполняющих нагрузку в объеме более 0,5 ставки',
        unit: '1 преподаватель',
        award: 0,
        empty: true,
      },
      {
        sequence: '2',
        title: 'Количество докторов наук, докторов философии (PhD), кандидатов наук РК',
        unit: '1 преподаватель',
        award: 50,
        empty: true,
      },
      {
        sequence: '3',
        title: 'Количество  преподавателей, получивших ученую степень:',
        hasChildren: true,
      },
      {
        sequence: '3.1',
        parent: '3',
        title: 'доктора PhD',
        unit: '1 преподаватель',
        award: 600,
        byTeacher: true,
        indicators: ['d89ea7ad-b2c2-4224-9672-18cc540e31cf']
      },
      {
        sequence: '3.2',
        parent: '3',
        title: 'заслуженный деятель искусства РК',
        unit: '1 преподаватель',
        award: 400,
        byTeacher: true,
        indicators: ['74ed0953-3610-4d59-b99a-0012d4a576cb']
      },
      {
        sequence: '3.3',
        parent: '3',
        title: 'заслуженный тренер РК',
        unit: '1 преподаватель',
        award: 400,
        byTeacher: true,
        indicators: ['5698d67e-6f8f-4880-918b-89179dc8e99e']
      },
      {
        sequence: '4',
        title: 'Количество  преподавателей, получивших ученое звание или судейскую категорию:',
        hasChildren: true,
      },
      {
        sequence: '4.1',
        parent: '4',
        title: 'профессора КОКСО / судьи Международной категории',
        unit: '1 преподаватель',
        award: 600,
        byTeacher: true,
        indicators: ['62e395f1-9a24-4bb2-89fa-8ebdda6ae12a']
      },
      {
        sequence: '4.2',
        parent: '4',
        title: 'ассоциированного профессора (доцента) КОКСО / судьи Высшей национальной категории',
        unit: '1 преподаватель',
        award: 400,
        byTeacher: true,
        indicators: ['bcedfd5a-bccc-46b7-aed0-e3edbc709fdf']
      },
      {
        sequence: '5',
        title: 'Количество  преподавателей, получивших грант и звание «Лучший преподаватель вуза»',
        unit: '1 преподаватель',
        award: 1000,
        byTeacher: true,
        indicators: ['63ae509d-2021-2022-86e5-477e5916943e']
      },
      {
        sequence: '6',
        title: 'Количество преподавателей, прошедших профессиональную переподготовку, повышение квалификации в организациях образования, научно-исследовательских организациях, организациях  дополнительного образования по общепедагогическому направлению.',
        unit: '1 преподаватель',
        award: 200,
        byTeacher: true,
        indicators: ['9a49f285-ef47-4097-b141-b4d5cc1ab6c6']
      },
      {
        sequence: '7',
        title: 'Количество преподавателей, прошедших обучение на курсах английского языка:',
        hasChildren: true,
      },
      {
        sequence: '7.1',
        parent: '7',
        title: 'продвинутый уровень;',
        unit: '1 преподаватель',
        award: 300,
        byTeacher: true,
        indicators: ['f1b97f4f-2021-2022-8341-7a88d74e6b29']
      },
      {
        sequence: '8',
        title: 'Количество преподавателей, получивших сертификат TOEFL, IELTS, FCE, CAE, TKT, ICELT, CELTA, DELTA, TESOL, Goethe-Zertifikat, DELF, DALF, TFI, TCF, DSH, TestDaF, DET,CEFR',
        unit: '1 преподаватель',
        award: 500,
        byTeacher: true,
        indicators: ['1f27140d-67b5-49bd-bc95-5bb4c97c186b']
      },
      {
        sequence: '9',
        title: 'Количество изданных учебников, учебных пособий с грифом МОН РК:',
        unit: '1 учебное пособие, учебник, ЭУИ',
        award: 1000,
        indicators: ['c550b2ca-2021-2022-b561-de396a1f6103'],
      },
      {
        sequence: '10',
        title: 'Количество полученных рекомендаций к изданию учебников, учебных пособий УМО РУМС базового вуза:',
        unit: '1 учебное пособие, учебник, ЭУИ',
        award: 500,
        indicators: ['d94fb148-2021-2022-99e5-d1aad3dc9ddf']
      },
      {
        sequence: '11',
        title: 'Количество изданных учебных и учебно-методических пособий, утвержденных УМС университета (с ISBN)',
        unit: '1 учебное пособие, учебник',
        award: 300,
        indicators: ['1a7db217-2021-2022-b1dc-26f40a99b754', 'a12ae085-2021-2022-af7a-d3605a0d2bc6']
      },
      {
        sequence: '12',
        title: 'Количество разработанных ЭУИ (в том, числе комлекс виртуальных лабораторных работ и моделирующих программ), утвержденных УМС университета',
        unit: '1 ЭУИ',
        award: 200,
        indicators: ['d6d919d9-1cde-4485-bfb8-54a17bc3c2e7']
      },
      {
        sequence: '13',
        title: 'Количество разработанных видеолекций по дисциплинам, утвержденных УМС университета',
        unit: '1 видео-лекция',
        award: 100,
        indicators: ['51b3ab17-e88c-4cca-8201-547d66fc259c']
      },
      {
        sequence: '14',
        title: 'Количество образовательных программ, закрепленных за кафедрой по которым ведется обучение в текущем учебном году:',
        hasChildren: true,
        empty: true,
      },
      {
        sequence: '14.1',
        parent: '14',
        title: 'бакалавриата;',
        unit: '1 ОП',
        award: 250,
        empty: true,
      },
      {
        sequence: '14.2',
        parent: '14',
        title: 'магистратуры;',
        unit: '1 ОП',
        award: 200,
        empty: true,
      },
      {
        sequence: '14.3',
        parent: '14',
        title: 'докторантуры.',
        unit: '1 ОП',
        award: 150,
        empty: true,
      },
      {
        sequence: '15',
        title: 'Количество реализуемых двудипломных образовательных программ',
        unit: '1 программа',
        award: 400,
        empty: true,
      },
      {
        sequence: '16',
        title: 'Количество преподавателей, проводивших занятия по одному предмету или модулю учебного плана в других вузах, в т.ч. казахстанских, иногородних',
        unit: '1 преподаватель',
        award: 300,
        empty: true,
      },
      {
        sequence: '17',
        title: 'Количество обучающихся, участвующих во внутренней академической мобильности',
        hasChildren: true,
        empty: true,
      },
      {
        sequence: '17.1',
        parent: '17',
        title: 'исходящая',
        unit: '1 обучающийся',
        award: 75,
        empty: true,
      },
      {
        sequence: '17.2',
        parent: '17',
        title: 'входящая',
        unit: '1 обучающийся',
        award: 100,
        empty: true,
      },
      {
        sequence: '18',
        title: 'Количество иностранных студентов на выпускающей кафедре, обучающихся на постоянной основе',
        unit: '1 обучающийся',
        award: 50,
        empty: true,
      },
      {
        sequence: '19',
        title: 'Количество действующих дистанционных курсов в Moodle, преподаваемых кафедрой в текущем учебном году',
        unit: '1 дисциплина',
        award: 10,
        empty: true,
      },
      {
        sequence: '20',
        title: 'Количество дистанционных олимпиад проведенных кафедрой  для старшеклассников и выпускников колледжей  (на платформе дистанционного обучения университета)',
        unit: '1 олимпиада',
        award: 100,
        indicators: ['50718d48-2021-2022-a1f5-09618a22dcb3']
      },
      {
        sequence: '21',
        title: 'Количество разработанных и внедренных курсов на платформах массовых открытых он-лайн курсов',
        unit: '1 курс',
        award: 2000,
        indicators: ['e517db52-2021-2022-b92e-2e7a18cd84d0']
      },
      {
        sequence: '22',
        title: 'Количество ППС кафедры, получивших сертификаты об успешном прохождении обучения по курсу на базе платформы массовых открытых онлайн курсов по профессиональной деятельности (на базе платформ Coursera, EdX, Udacity, FutureLearn):',
        unit: '1 преподаватель',
        award: 200,
        byTeacher: true,
        indicators: ['8e65260f-2021-2022-ae8e-d1572787b929']
      },
      {
        sequence: '23',
        title: 'Количество ППС кафедры, участвующих в проекте «Корпоративного обучения»',
        unit: '1 преподаватель',
        award: 200,
        byTeacher: true,
        indicators: ['90fcfab6-2021-2022-a079-1f37d0e9775f', '408d0e20-2021-2022-9b01-118d34bbaf40', '9386d568-2021-2022-9255-411dcb8fcd29', '9386d568-2021-2022-9255-411dcb8fcd25']
      },
      {
        sequence: '24',
        title: 'Оказание образовательных услуг с перечислением средств на счет университета, в том числе проведение специализированных курсов для сторонних организаций, сотрудников КРУ и других лиц',
        unit: '100 тыс. тенге',
        coefficient: 100000,
        award: 100,
        indicators: ['5531fc0b-c2ae-4042-a88b-5101e3b3314a']
      },
      {
        sequence: '25',
        title: 'Количество неязыковых дисциплин, преподаваемых преподавателями кафедры на английском языке.',
        unit: '1 дисциплина',
        award: 200,
        indicators: ['37043f6e-9d8c-4857-b58a-b0c6589589ef']
      },
      {
        sequence: '26',
        title: 'Количество реализуемых научных проектов с грантовым финансированием',
        unit: '1 проект',
        award: 600,
        indicators: ['445a4bf8-5f15-40af-af6f-dd3779a40225']
      },
      {
        sequence: '27',
        title: 'Количество разрабатываемых тем НИР (грант научных проектов МОН, инициативные и др.), зарегистрированных в НЦГНТЭ',
        unit: '1 отчет',
        award: 200,
        indicators: ['5a989633-e576-49a2-a6c7-e5f6a14a1f60']
      },
      {
        sequence: '28',
        title: 'Государственно-частное партнерство с финансированием – за каждые 100 тыс. тенге, поступивших на счет университета по хоздоговору',
        unit: '100 тыс. тенге',
        coefficient: 100000,
        award: 100,
        indicators: ['9c307f0d-39c0-44b6-919e-01dc1a4f98dd']
      },
      {
        sequence: '29',
        title: 'Количество обучающихся, победителей конкурсов НИРС (НИРМ)  предметных олимпиад, которых подготовил ППС кафедры:',
        hasChildren: true,
        empty: true,
      },
      {
        sequence: '29.1',
        parent: '29',
        title: 'республиканских МОН РК',
        unit: '1  диплом, грамота',
        award: 300,
        // empty: true,
        indicators: ['06ec0ace-b328-4860-bb85-47df8097a555']
      },
      {
        sequence: '29.2',
        parent: '29',
        title: 'республиканских МОН РК (для школьников)',
        unit: '1  диплом, грамота',
        award: 50,
        // empty: true,
        indicators: ['8d110365-8f16-47fb-82b3-29c0b40d9c62']
      },
      {
        sequence: '29.3',
        parent: '29',
        title: 'международных в РК (очное участие республиканского уровня)',
        unit: '1  диплом, грамота',
        award: 200,
        // empty: true,
        indicators: ['be6b7f86-90f0-46fc-bc1c-958e3b6ebcea']
      },
      {
        sequence: '29.4',
        parent: '29',
        title: 'международных в РК (очное участие регионального уровня)',
        unit: '1  диплом, грамота',
        award: 150,
        // empty: true,
        indicators: ['a48b117a-1471-4aba-9534-3bb69b452b2e']
      },
      {
        sequence: '29.5',
        parent: '29',
        title: 'международных в РК (дистанционное участие республиканского уровня)',
        unit: '1  диплом, грамота',
        award: 180,
        // empty: true,
        indicators: ['30296863-80be-4128-bc62-25283d79125e']
      },
      {
        sequence: '29.6',
        parent: '29',
        title: 'международных в РК (дистанционное участие регионального уровня)',
        unit: '1  диплом, грамота',
        award: 130,
        // empty: true,
        indicators: ['5b4c8a94-f520-4570-a246-a90db56c6ce4']
      },
      {
        sequence: '29.7',
        parent: '29',
        title: 'международных - ближнее зарубежье (очное участие вузы партнеры)',
        unit: '1  диплом, грамота',
        award: 250,
        // empty: true,
        indicators: ['c516f289-44db-4f0b-83cd-20c8abc86f4a']
      },
      {
        sequence: '29.8',
        parent: '29',
        title: 'международных - ближнее зарубежье (очное участие другие вузы и образовательные организации)',
        unit: '1  диплом, грамота',
        award: 230,
        // empty: true,
        indicators: ['b73bc4d6-daf8-4e1f-8376-8ebc4b039845']
      },
      {
        sequence: '29.9',
        parent: '29',
        title: 'международных - ближнее зарубежье (дистанционное участие вузы партнеры)',
        unit: '1  диплом, грамота',
        award: 230,
        // empty: true,
        indicators: ['1e1892f8-78eb-493f-8dbf-c5e1e4a9a944']
      },
      {
        sequence: '29.10',
        parent: '29',
        title: 'международных - ближнее зарубежье (дистанционное участие другие вузы и образовательные организации)',
        unit: '1  диплом, грамота',
        award: 200,
        // empty: true,
        indicators: ['505edd58-0b18-4586-a13f-47112c94d831']
      },
      {
        sequence: '29.11',
        parent: '29',
        title: 'международных - дальнее зарубежье',
        unit: '1  диплом, грамота',
        award: 300,
        // empty: true,
        indicators: ['9e1c7158-aebb-4974-bdbc-a5c9fc15a7b4']
      },
      {
        sequence: '30',
        title: 'Количество внедренных результатов НИР ППС',
        hasChildren: true,
      },
      {
        sequence: '30.1',
        parent: '30',
        title: 'внедрение патента в производство (бизнес) с оплатой на счет университета от 50 тысяч тенге',
        unit: '1 акт внедрения',
        award: 1000,
        indicators: ['3b91a7fa-9b00-4b22-aead-e274e58c9df5']
      },
      {
        sequence: '31',
        title: 'Количество студенческих',
        hasChildren: true,
      },
      {
        sequence: '31.1',
        parent: '31',
        title: 'стартапов с регистрацией бизнеса, подтверждённых созданием рабочих мест и налоговыми отчислениями',
        unit: '1 стартап, бизнес-проект',
        award: 2000,
        indicators: ['eb26a64d-a515-4e38-a6ab-5762225a44f9']
      },
      {
        sequence: '31.2',
        parent: '31',
        title: 'бизнес-проектов и эссе, выигравших грантовое финансирование',
        unit: '1 стартап, бизнес-проект',
        award: 200,
        indicators: ['7992f14e-35ce-4fe8-a900-39f5f612eb42']
      },
      {
        sequence: '32',
        title: 'Количество организованных научных и методических мероприятий',
        hasChildren: true,
        empty: true
      },
      {
        sequence: '32.1',
        parent: '32',
        title: 'международного уровня в рамках конференций «Байтурсыновские чтения«, «Султангазинские чтения», «Алтынсаринские чтения»',
        unit: '1 мероприятие',
        award: 300,
        empty: true,
      },
      {
        sequence: '32.2',
        parent: '32',
        title: 'в рамках конференции «ИННОВА«',
        unit: '1 мероприятие',
        award: 300,
        empty: true,
      },
      {
        sequence: '32.3',
        parent: '32',
        title: 'региональных',
        unit: '1 мероприятие',
        award: 100,
        empty: true,
      },
      {
        sequence: '32.4',
        parent: '32',
        title: 'институтского и кафедрального уровней',
        unit: '1 мероприятие',
        award: 50,
        empty: true,
      },
      {
        sequence: '33',
        title: 'Количество полученных:',
        hasChildren: true,
      },
      {
        sequence: '33.1',
        parent: '33',
        title: 'патентов',
        unit: '1 патент',
        award: 400,
        indicators: ['1ee934e4-2209-437c-977b-ed0ebca565a8']
      },
      {
        sequence: '33.2',
        parent: '33',
        title: 'свидетельств интеллектуальной собственности',
        unit: '1 свидетельство',
        award: 400,
        indicators: ['c3280848-0021-4673-93b6-460e69eb347f']
      },
      {
        sequence: '33.3',
        parent: '33',
        title: 'свидетельство интеллектуальной собственности на ЭУИ',
        unit: '1 свидетельство',
        award: 400,
        indicators: ['ff6ca178-ab51-42a2-a85a-4796877f3314']
      },
      {
        sequence: '33.4',
        parent: '33',
        title: 'публикации патентов  в патентной базе Derwent Innovations Index компании Creative Analytics',
        unit: '1 публикация',
        award: 200,
        indicators: ['b855d844-8b8a-4b8f-a9f8-ffd3558ccb66']
      },
      {
        sequence: '34',
        title: 'Количество изданных монографий:',
        unit: '1 монография',
        award: 500,
        indicators: ['65f76b4b-2021-2022-8cb2-63227c32af89']
      },
      {
        sequence: '35',
        title: 'Количество опубликованных научных статей в научных изданиях (в т.ч. со студентами, магистрантами, докторантами):',
        hasChildren: true,
      },
      {
        sequence: '35.1',
        parent: '35',
        title: 'индексируемых в Web of Science, Thomson Reuters, Scopus',
        unit: '1 статья',
        award: 1000,
        indicators: ['7ae9b3e7-648a-4c7c-825d-ce21e2ca12ad']
      },
      {
        sequence: '35.2',
        parent: '35',
        title: 'индексируемых в Pubmed, zbMath, MathScinet, Agris, Georef, Astrophysical journal',
        unit: '1 статья',
        award: 500,
        indicators: ['b512e370-eba0-4bca-be12-df710433ff97']
      },
      {
        sequence: '35.3',
        parent: '35',
        title: 'в журналах, рекомендованных КОКСО МОН РК',
        unit: '1 статья',
        award: 250,
        indicators: ['4a3de34c-87cc-4d9a-8663-254e8a40866e']
      },
      {
        sequence: '35.4',
        parent: '35',
        title: 'в журналах, рекомендованных ВАК России, Белоруссии, Кыргызстана',
        unit: '1 статья',
        award: 150,
        indicators: ['6435c434-9c7a-476f-8f72-791624f3cb05']
      },
      {
        sequence: '35.5',
        parent: '35',
        title: 'в журнале «3i», «Вестник КГПИ»',
        unit: '1 статья',
        award: 150,
        indicators: ['35c6f365-9345-48b7-a624-8d7c227a0c9f']
      },
      {
        sequence: '35.6',
        parent: '35',
        title: 'совместные публикации в журналах «3i», «Вестник КГПИ» с иностранным ученым',
        unit: '1 статья',
        award: 50,
        indicators: ['b3a926b8-6ca6-4858-bfb7-f0e0e68c6c66']
      },
      {
        sequence: '36',
        title: 'Количество ППС кафедры, имеющих h-индекс (индекс Хирша) 2 и более',
        hasChildren: true,
      },
      {
        sequence: '36.1',
        parent: '36',
        title: 'Web of Science и Scopus',
        unit: '1 преподаватель',
        award: 500,
        byTeacher: true,
        indicators: ['f9ec90ed-84a8-45c1-8a4b-19b932d23c6e']
      },
      {
        sequence: '36.2',
        parent: '36',
        title: 'Elibrary, РИНЦ',
        unit: '1 преподаватель',
        award: 200,
        byTeacher: true,
        indicators: ['79a58a56-6d63-4554-a18b-b7c16d339c1b']
      },
      {
        sequence: '37',
        title: 'Количество реализуемых международных проектов с грантовым финансированием',
        unit: '1 проект',
        award: 600,
        indicators: ['b1869ddf-e701-4259-a9dc-862dc4921a16']
      },
      {
        sequence: '38',
        title: 'Количество командировок и стажировок в зарубежные образовательные и научные учреждения:',
        hasChildren: true,
      },
      {
        sequence: '38.1',
        parent: '38',
        title: 'командировка (длительность до 5 дней)',
        unit: '1 командировка',
        award: 50,
        indicators: ['b5c9918d-d46f-4a4a-ad03-75d3de3098bd']
      },
      {
        sequence: '38.2',
        parent: '38',
        title: 'стажировка',
        unit: '1 стажировка',
        award: 200,
        indicators: ['4a7ea449-09ce-4211-a3bc-b90f11eeecd3']
      },
      {
        sequence: '39',
        title: 'Количество зарубежных ученых, приглашенных в университет:',
        hasChildren: true,
        empty: true
      },
      {
        sequence: '39.1',
        parent: '39',
        title: 'не менее 1-ой недели',
        unit: '1 ученый',
        award: 300,
        empty: true,
      },
      {
        sequence: '39.2',
        parent: '39',
        title: 'менее 1-ой недели',
        unit: '1 ученый',
        award: 50,
        empty: true,
      },
      {
        sequence: '40',
        title: 'Количество обучающихся, участвующих во внешней академической мобильности (на семестр, год):',
        hasChildren: true,
        empty: true
      },
      {
        sequence: '40.1',
        parent: '40',
        title: 'исходящая',
        unit: '1 обучающийся',
        award: 150,
        empty: true,
      },
      {
        sequence: '40.2',
        parent: '40',
        title: 'входящая',
        unit: '1 обучающийся',
        award: 200,
        empty: true,
      },
      {
        sequence: '41',
        title: 'Количество преподавателей, являющихся победителями конкурсов «Лучший куратор института» (1,2,3 места)',
        unit: '1 преподаватель',
        award: 100,
        byTeacher: true,
        indicators: ['944a67be-ddd7-430c-aa3b-1214adb6e473', 'ea5c6c6e-628a-49b5-8eb7-b630e14754a4', '6d5d4b17-5008-40c4-abf8-0c6cb9e81777']
      },
      {
        sequence: '42',
        title: 'Количество преподавателей, являющихся победителями конкурсов «Лучший куратор университета» (1,2,3 места)',
        unit: '1 преподаватель',
        award: 200,
        byTeacher: true,
        indicators: ['6d5d4b17-5008-40c4-abf8-0c6666e81b11', '6d5d4b17-5008-40c4-abf8-0c6666e81b22', '6d5d4b17-5008-40c4-abf8-0c6666e81b33']
      },
      {
        sequence: '43',
        title: 'Количество преподавателей, проводивших воспитательные мероприятия на базе университета:',
        hasChildren: true,
      },
      {
        sequence: '43.1',
        parent: '43',
        title: 'международного уровня',
        unit: '1 преподаватель',
        award: 300,
        byTeacher: true,
        indicators: ['50499dec-245b-4746-b1f6-7e023d9e341b']
      },
      {
        sequence: '43.2',
        parent: '43',
        title: 'республиканского уровня',
        unit: '1 преподаватель',
        award: 200,
        byTeacher: true,
        indicators: ['6ef07b73-234c-4765-b2fc-3b06f3c563ff']
      },
      {
        sequence: '43.3',
        parent: '43',
        title: 'университетского уровня',
        unit: '1 преподаватель',
        award: 150,
        byTeacher: true,
        indicators: ['3577e76a-5bb3-4040-a9b1-20e8f9a24833']
      },
      {
        sequence: '43.4',
        parent: '43',
        title: 'институтского уровня',
        unit: '1 преподаватель',
        award: 100,
        byTeacher: true,
        indicators: ['479aba2b-b9ff-4378-aa1e-e95cae0cfcd3']
      },
      {
        sequence: '43.5',
        parent: '43',
        title: 'кафедрального уровня',
        unit: '1 преподаватель',
        award: 50,
        byTeacher: true,
        indicators: ['1b395c55-b799-46ae-9212-69150f6fae5c']
      },
      {
        sequence: '44',
        title: 'Количество обучающихся, призеров фестивалей, конкурсов, турниров:',
        hasChildren: true,
        empty: true,
      },
      {
        sequence: '44.1',
        parent: '44',
        title: 'международных',
        unit: '1 обучающийся',
        award: 300,
        empty: true,
        // indicators: ['']
      },
      {
        sequence: '44.2',
        parent: '44',
        title: 'республиканских',
        unit: '1 обучающийся',
        award: 200,
        empty: true,
        // indicators: ['']
      },
      {
        sequence: '44.3',
        parent: '44',
        title: 'областных',
        unit: '1 обучающийся',
        award: 100,
        empty: true,
        // indicators: ['']
      },
      {
        sequence: '45',
        title: 'Количество обучающихся, призеров спортивных соревнований (1,2,3 место в личных и общекомандных соревнованиях):',
        hasChildren: true,
      },
      {
        sequence: '45.1',
        parent: '45',
        title: 'международных (зарубежных)',
        unit: '1 обучающийся',
        award: 400,
        indicators: ['e1efaa16-f65d-4e1e-b9e2-5f9a6e279f96']
      },
      {
        sequence: '45.2',
        parent: '45',
        title: 'международных (в РК)',
        unit: '1 обучающийся',
        award: 300,
        indicators: ['a3665548-b340-4406-8952-d34479a34df5']
      },
      {
        sequence: '45.3',
        parent: '45',
        title: 'республиканские',
        unit: '1 обучающийся',
        award: 200,
        indicators: ['d16fae7e-cda9-41e6-9425-3e381b795707']
      },
      {
        sequence: '46',
        title: 'Количество обучающихся, получивших:',
        hasChildren: true,
      },
      {
        sequence: '46.1',
        parent: '46',
        title: 'мастера спорта международного класса',
        unit: '1 обучающийся',
        award: 200,
        indicators: ['5de22343-3af2-4c4e-b224-bcfa2f5da8d7']
      },
      {
        sequence: '46.2',
        parent: '46',
        title: 'мастера спорта РК',
        unit: '1 обучающийся',
        award: 150,
        indicators: ['1e6c4dd1-39f4-471c-a4be-aab427201f1b']
      },
      {
        sequence: '46.3',
        parent: '46',
        title: 'кандидата в мастера спорта (первый взрослый разряд по игровым видам спорта)',
        unit: '1 обучающийся',
        award: 100,
        indicators: ['df0d1f67-32ed-4562-8c52-798c0ba7f073']
      },
      {
        sequence: '47',
        title: 'Количество обучающихся, участников волонтерского движения',
        unit: '1 обучающийся',
        award: 100,
        empty: true,
      },
      {
        sequence: '48',
        title: 'Количество обучающихся, участников студенческих клубов, трудовых отрядов,  творческих объединений , членов общественных молодежных организаций и др.',
        unit: '1 обучающийся',
        award: 50,
        empty: true,
      },
      {
        sequence: '49',
        title: 'Набор студентов на 1 курс очной формы обучения',
        unit: '1 обучающийся',
        award: 10,
        empty: true,
      },
      {
        sequence: '50',
        title: 'Количество малокомплектных групп в бакалавриате',
        unit: '1 группа',
        award: -100,
        empty: true,
      },
      {
        sequence: '51',
        title: 'Выступления и размещение кафедрами информации об образовательных программах кафедр, деятельности университета в средствах массовой информации',
        unit: '1 статья, эфирная справка с указанием тематики выхода',
        award: 50,
        indicators: ['d4b96575-121c-41bb-bc9e-957a9c128dbf']
      },
      {
        sequence: '52',
        title: 'Итоги рейтинга НПП РК «Атамекен»',
        unit: '',
        award: 0,
        empty: true,
      },
      {
        sequence: '53',
        title: 'Дополнительные баллы по предложению директора института и руководителей структурных подразделений университета  за выполнение определенных видов работы.',
        unit: '',
        award: 0,
        empty: true,
      },
    ]
  }),
  watch: {
    selectedIndicators: {
      deep: true,
      handler () {
        const indicators = this.indicators.filter(indicator => this.selectedIndicators.includes(indicator.sequence))
        this.$emit('input', indicators)
      },
    },
  },
  computed: {
    indicators () {
      const p = this.period.substring(0, 4)
      return this[`indicators_${p}`]
    }
  },
  mounted() {
    this.selectedIndicators = []

    this.toggleAllIndicators()
  },
  methods: {
    toggleAllIndicators () {
      this.selectedIndicators = []

      if (this.selectAllIndicators) {
        this.indicators.forEach(indicator => {
          this.selectedIndicators.push(indicator.sequence)
        })
      }
    },
    selectIndicator (indicator) {
      const select = this.selectedIndicators.find(selected => selected === indicator.sequence)

      if (select) {
        if (indicator.parent && !this.selectedIndicators.find(selected => selected === indicator.parent)) {
          this.selectedIndicators.push(indicator.parent)
        }

        this.indicators
            .filter(i => i.parent && (i.parent === indicator.sequence))
            .forEach(i => {
              let exist = this.selectedIndicators.find(selected => selected === i.sequence)
              if (!exist) {
                this.selectedIndicators.push(i.sequence)
              }
            })
      } else {
        if (indicator.parent && this.selectedIndicators.find(selected => selected === indicator.parent)) {
          const children = this.indicators.filter(i => i.parent && (i.parent === indicator.parent))

          let hasSelectedChildren = false

          children.forEach(child => {
            const selectedChildIndex = this.selectedIndicators.findIndex(selected => selected === child.sequence)
            if (selectedChildIndex >= 0) {
              hasSelectedChildren = true
            }
          })

          if (!hasSelectedChildren) {
            const parentIndex = this.selectedIndicators.findIndex(selected => selected === indicator.parent)
            this.selectedIndicators.splice(parentIndex, 1)
          }
        }

        this.indicators
            .filter(i => i.parent && (i.parent === indicator.sequence))
            .forEach(child => {
              const index = this.selectedIndicators.findIndex(selected => selected === child.sequence)
              if (index >= 0) {
                this.selectedIndicators.splice(index, 1)
              }
            })
      }
    }
  },
}
</script>
